import { createTheme, responsiveFontSizes, adaptV4Theme } from '@mui/material/styles';
import { ruRU } from '@mui/material/locale';
import { red } from '@mui/material/colors';
import tinycolor from 'tinycolor2';

import { getAppContext } from './utils/helpers/appContext.helper';

const COLORS = {
    tennisAccent: 'rgb(231, 30, 43)',
    padelAccent: 'rgb(59, 41, 66)',
    brandDark: 'rgb(59, 41, 66)',
    secondary: 'rgb(203, 211, 227)'
};

const { isPadel } = getAppContext();
const primaryMain = isPadel ? COLORS.padelAccent : COLORS.tennisAccent;
const primaryHover = isPadel
    ? tinycolor(primaryMain).lighten(3).toString()
    : tinycolor(primaryMain).lighten(5).toString();
const primaryHoverStrong = isPadel
    ? tinycolor(primaryMain).lighten(5).toString()
    : tinycolor(primaryMain).lighten(8).toString();
const primarySoft = isPadel
    ? 'rgba(59, 41, 66, 0.1)'
    : tinycolor(primaryMain).lighten(45).toString();
const primarySoftHover = isPadel
    ? 'rgba(59, 41, 66, 0.16)'
    : tinycolor(primaryMain).lighten(40).toString();

const theme = responsiveFontSizes(
    createTheme(
        adaptV4Theme({
            spacing: 4,
            typography: {
                fontFamily: ['GT-Pressura-LC', 'sans-serif'].join(', '),
                fontSize: 10
            },
            palette: {
                primary: {
                    main: primaryMain,
                    dark: COLORS.brandDark,
                    contrastText: '#fff',
                    hover: primaryHover,
                    hoverStrong: primaryHoverStrong,
                    soft: primarySoft,
                    softHover: primarySoftHover
                },
                secondary: {
                    main: COLORS.secondary,
                    contrastText: COLORS.brandDark
                },
                error: {
                    main: red.A400
                },
                text: {
                    primary: COLORS.brandDark
                }
            },
            overrides: {
                MuiCssBaseline: {
                    '@global': {
                        html: {},
                        body: {
                            margin: 0
                        },
                        main: {
                            display: 'block',
                            boxSizing: 'border-box'
                        },
                        ul: {
                            margin: 0,
                            padding: 0
                        },
                        li: {
                            margin: 0,
                            padding: 0
                        }
                    }
                },
                MuiButton: {
                    root: {
                        textTransform: 'none',
                        fontSize: 16,
                        height: 40,
                        fontWeight: 100,

                        '&:hover': {
                            backgroundColor: 'none'
                        }
                        // [breakpoints.down('md')]: {
                        //     fontSize: 14
                        // }
                    },
                    textPrimary: {
                        paddingLeft: 20,
                        paddingRight: 20
                    }
                },
                MuiTextField: {
                    root: {
                        '& label.Mui-focused': {
                            color: COLORS.brandDark
                        },
                        '& .MuiInput-underline:after': {
                            borderBottomColor: COLORS.brandDark
                        },
                        '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                                borderColor: COLORS.brandDark
                            },
                            '&.Mui-focused fieldset': {
                                borderColor: COLORS.brandDark
                            }
                        }
                    }
                },
                MuiFilledInput: {
                    root: {
                        backgroundColor: COLORS.secondary
                    },
                    underline: {
                        '&:after': {
                            borderBottomWidth: '2px'
                        },
                        '&:before': {
                            borderColor: '#000',
                            borderBottomWidth: '2px'
                        }
                    },
                    input: {
                        backgroundColor: 'rgb(245, 248, 250)'
                    }
                },
                MuiDialog: {
                    paper: {
                        borderRadius: 12
                    }
                },
                MuiDialogActions: {
                    root: {
                        marginBottom: 8
                    }
                },
                MuiDialogTitle: {
                    root: {
                        borderBottom: '1px solid rgb(204, 214, 221)',
                        marginBottom: 10,
                        padding: '10px 15px',
                        '& h2': {
                            display: 'flex',
                            alignItems: 'center',
                            fontWeight: 800
                        },
                        '& button': {
                            padding: 8,
                            marginRight: 20
                        }
                    }
                }
                // MuiGrid: {
                //     container: {
                //         position: 'relative'
                //     }
                // }
            },
            props: {
                MuiCheckbox: {
                    disableRipple: true
                },
                MuiTextField: {
                    variant: 'outlined'
                }
            }
        }),
        ruRU
    )
);

export default theme;
